export default {"src":"/_next/static/media/left-bg.b5184496.svg","height":485,"width":244,"blurWidth":0,"blurHeight":0};